export const Logo = ({ h = 40, withWordmark = true }) => (
  <span className="inline-flex items-center select-none">
    <img
      src="/tacctax-logo.png"
      alt="TaccTax — Transforming complexity into clarity"
      style={{ height: h }}
      className="w-auto"
      data-testid="brand-logo-image"
    />
    {withWordmark && (
      <span className="hidden sm:block leading-none ml-3 pl-3 border-l border-line">
        <span className="block font-mono text-[9px] uppercase tracking-[0.28em] text-slate-400">
          Solution Pvt. Ltd.
        </span>
        <span className="block font-mono text-[9px] uppercase tracking-[0.28em] text-slate-400 mt-1">
          Offshore KPO Partner
        </span>
      </span>
    )}
  </span>
);

export default Logo;
